import { call, put, select } from "redux-saga/effects";
import { initiateCallAction } from "../../userAgent/initiateCall/action";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";
import { setIsMergingCalls } from "../../../state/activeCallScreen/activeCallScreenSlice";
import cirrusClient from "../../../services/api/cirrus-client";


export function* mergeCallSessionsSaga(action) {
    try {
        yield put(setIsMergingCalls(true));
        // Fetch user credentials from Redux store
        const { uid } = yield select(selectUserCredentials);
        const callIds = action.payload;
        const params = {
            object: 'call',
            action: 'merge',
            uid: uid,
            callids: callIds,
            format: 'json'
        };
        const response = yield call(cirrusClient.get, '/', { params });
        if (response.status === 200) {
            const destination = response.data[0].destination;

            // Dispatch the initiateCallAction with the phoneNumber, also sending isConference as a parameter
            yield put(initiateCallAction({ 
                phoneNumber: destination,
                isConference: true,
             }));
        } else {
            throw new Error('Failed to merge calls');
        }

    } catch (error) {
        console.error('Error merging calls:', error);
        yield put(setIsMergingCalls(false));
    }


}